export default __webpack_public_path__ + "static/media/ChangePassword.026d64c3.svg";